import { client } from "./client";
import {
  Host, HostCreateRequest, HostPasswordResetRequest, HostUpdateRequest,
} from "../types/Host";

export function apiCreateHost(
  organizationId: number,
  workspaceId: number,
  hostCreateRequest: HostCreateRequest
) {
  return client.post(
    `/organizations/${organizationId}/workspaces/${workspaceId}/hosts`,
    hostCreateRequest
  );
}

export function apiGetHosts(
  organizationId: number,
  workspaceId: number
) {
  return client.get(
    `/organizations/${organizationId}/workspaces/${workspaceId}/hosts`
  );
}

export function apiUpdateHost(
  organizationId: number,
  workspaceId: number,
  hostId: number,
  hostUpdateRequest: HostUpdateRequest
) {
  return client.put(
    `/organizations/${organizationId}/workspaces/${workspaceId}/hosts/${hostId}`,
    hostUpdateRequest
  );
}

export function apiResetHostPassword(
  organizationId: number,
  workspaceId: number,
  hostId: number,
  hostPasswordResetRequest: HostPasswordResetRequest
) {
  return client.put(
    `/organizations/${organizationId}/workspaces/${workspaceId}/hosts/${hostId}/reset`,
    hostPasswordResetRequest
  );
}